export default "__VITE_ASSET__B2kl4A7e__"